"use client";

import * as React from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  COMMAND_PRIORITY_LOW,
  KEY_TAB_COMMAND,
  INDENT_CONTENT_COMMAND,
  OUTDENT_CONTENT_COMMAND,
  $getNodeByKey,
  $getSelection,
  $isRangeSelection,
} from "lexical";
import { $isListItemNode } from "@lexical/list";
import { findClosestBlockNodeKey } from "../../kernel/helpers/findClosestBlockNodeKey";

export function KeyboardListIndentPlugin({ isEditable }: { isEditable: boolean }) {
  const [editor] = useLexicalComposerContext();
  const MAX_LIST_DEPTH = 8;

  React.useEffect(() => {
    if (!isEditable) return;

    return editor.registerCommand(
      KEY_TAB_COMMAND,
      (event: KeyboardEvent) => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) return false;
        const key = findClosestBlockNodeKey(selection.anchor.getNode());
        if (!key) return false;
        const node = $getNodeByKey(key);
        if (!$isListItemNode(node)) return false;

        event.preventDefault();
        if (event.shiftKey) {
          editor.dispatchCommand(OUTDENT_CONTENT_COMMAND, undefined);
        } else {
          // 放宽为可继续缩进，并设置合理上限，避免无限层级
          let depth = 0;
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          let p: any = node.getParent?.();
          while (p) {
            if ($isListItemNode(p)) depth += 1;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            p = (p as any).getParent?.();
          }
          if (depth >= MAX_LIST_DEPTH) return true;
          editor.dispatchCommand(INDENT_CONTENT_COMMAND, undefined);
        }
        return true;
      },
      COMMAND_PRIORITY_LOW,
    );
  }, [editor, isEditable]);

  return null;
}

